export default __webpack_public_path__ + "images/94680578888e63f8114ee0dfa8868e57.svg";